import React from 'react';
import { GiftIcon, GlassesIcon, StickerIcon, TicketIcon, ShirtIcon } from 'lucide-react';
import { Product } from '../../types/content';
type ProductImageProps = {
  product: Product;
  className?: string;
};
const kindIcon = {
  apparel: ShirtIcon,
  deposit: TicketIcon,
  gift: GiftIcon,
  sticker: StickerIcon,
  inhouse: GlassesIcon
};
export function ProductImage({
  product,
  className = ''
}: ProductImageProps) {
  if (product.image) {
    return <img src={product.image} alt={product.name} loading="lazy" className={`h-full w-full object-cover ${className}`} data-id="element-214" data-mp="2mot16jjf45xb" />;
  }
  const Icon = kindIcon[product.kind];
  return <div className={`flex h-full w-full flex-col items-center justify-center gap-4 border border-ink-line bg-ink-surface p-6 text-center ${className}`} data-id="element-215" data-mp="2wnij2cbbdqdk">
      <Icon className="h-14 w-14" strokeWidth={1} aria-hidden="true" data-id="element-216" data-mp="240nyzgiest0m" />
      <span className="font-slab text-xs font-bold uppercase tracking-[0.25em] text-ink-muted" data-id="element-217" data-mp="23yblbfjop4td">Trip Ink Tattoo Co.</span>
    </div>;
}